import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import logo from '../assets/images/hey-visuals-logo.png';
import delat from '../assets/images/dummy-user.jpg';
import { useProfileImage } from './useProfileImage';
import { useNavigate, useLocation, useParams } from 'react-router-dom';

const Emailconfirm = () => {

    const [loading, setLoading] = useState(false)
    const { id1, id2 } = useParams();
    const location = useLocation();
    const [isDropdownOpen, setDropdownOpen] = useState(false);
    const { profileImage } = useProfileImage();
    const navigate = useNavigate();
    const dropdownRef = useRef(null);

    const toggleDropdown = () => {
        setDropdownOpen(!isDropdownOpen);
    };

    const closeDropdown = () => {
        setDropdownOpen(false);
    };

    const [nameData, setNameData] = useState({
        name: "",
        email: "",
    });

    const handlesignout = () => {
        localStorage.removeItem('auth');
        setTimeout(() => {
            navigate('/login');
        }, 100);
    };

    useEffect(() => {
        try {
            const authData = localStorage.getItem('auth');
            const storedName = authData ? JSON.parse(authData).name : null;
            const storedEmail = authData ? JSON.parse(authData).email : null;
            setNameData({
                name: storedName,
                email: storedEmail,
            });
        } catch (error) {
            console.error("Error retrieving data from localStorage:", error);
        }
    }, []);

    useEffect(() => {
        const authData = localStorage.getItem('auth');
        const verifyEmail = authData ? JSON.parse(authData).email_verified_at : null;
        const verifySyEmail = async () => {
            setLoading(true)
            if (!verifyEmail) {
                setLoading(true)
                if (id1 && id2) {
                    setLoading(true)
                    const authData = localStorage.getItem('auth');
                    const token = authData ? JSON.parse(authData).token : null;
                    try {
                        const response = await axios.get(
                            `${process.env.REACT_APP_API_URL}/api/email/verify/${id1}/${id2}`,
                            {
                                headers: {
                                    Authorization: `Bearer ${token}`,
                                },
                            }
                        );
                        if (response.data.status === 200) {
                            const authData = localStorage.getItem('auth');
                            const aData = JSON.parse(authData);
                            const now = new Date();
                            const formattedDate = now.getFullYear() + '-' +
                                ('0' + (now.getMonth() + 1)).slice(-2) + '-' +
                                ('0' + now.getDate()).slice(-2) + ' ' +
                                ('0' + now.getHours()).slice(-2) + ':' +
                                ('0' + now.getMinutes()).slice(-2) + ':' +
                                ('0' + now.getSeconds()).slice(-2);
                            aData.email_verified_at = formattedDate;
                            localStorage.setItem('auth', JSON.stringify(aData));
                            navigate('/');
                        } else if (response.data.status === 422) {
                            navigate('/');
                        } else if (response.data.status === 401) {
                            navigate('/');
                        }
                    } catch (error) {
                        console.error('There was an error resending the verification email:', error);
                    }
                }
            } else {
                navigate('/');
            }
        }
        verifySyEmail();
    }, [id1, id2])

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                closeDropdown();
            }
        };
        document.addEventListener('click', handleClickOutside);
        return () => {
            document.removeEventListener('click', handleClickOutside);
        };
    }, []);


    return (
        <div style={{ backgroundColor: '#F9F9F9', height: '100vh', display: 'flex', flexDirection: 'column', justifyContent: 'space-between', overflowX: 'hidden' }}>
            <div>
                <header id="kt_header" className="header align-items-stretch header-fixed" style={{ position: 'fixed', top: "0px", width: '100%', zIndex: '1000', boxShadow: '0 0 6px rgba(0, 0, 0, .15)', backgroundColor: 'rgba(255, 255, 255, 1)', }}>
                    <div className="container-fluid d-flex align-items-stretch justify-content-between">

                        {/* Center Logo */}
                        <div className="d-flex align-items-center justify-content-center flex-lg-grow-1">
                            <Link to="/" className="text-center ">
                                <img src={logo} alt="logo" width="40%" />
                            </Link>
                        </div>

                        {/* User Menu */}
                        <div className="d-flex align-items-stretch justify-content-end">
                            <div className="d-flex align-items-stretch flex-shrink-0">
                                <div id="kt_header_user_menu_toggle"
                                    ref={dropdownRef}
                                    className="d-flex align-items-center ms-1 ms-lg-3 kt_header_user_menu_toggle_top" >
                                    <div  style={{ paddingRight: "18px" }}
                                        onClick={toggleDropdown}
                                        className="cursor-pointer symbol symbol-30px symbol-md-40px" >
                                        <img src={profileImage || delat}
                                            alt="User"
                                            className="user-image"/>
                                    </div>

                                    {/* User Dropdown Menu */}
                                    <div
                                        className="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-800 menu-state-bg menu-state-color fw-semibold py-4 fs-6 w-275px"
                                        style={{
                                            display: isDropdownOpen ? "block" : "none",
                                            boxShadow: "0 3px 5px rgb(185 188 188)",
                                        }}>
                                        <div className="menu-item px-3">
                                            <div className="menu-content d-flex align-items-center px-3">
                                                <div className="symbol symbol-50px me-3">
                                                    <img
                                                        alt="User Logo"
                                                        src={profileImage || delat}
                                                        className="user-image"
                                                    />
                                                </div>
                                                <div className="d-flex flex-column">
                                                    <div className="fw-bold d-flex align-items-center fs-5 user-name">
                                                        {nameData.name}
                                                    </div>
                                                    <a
                                                        href="#email"
                                                        className="fw-semibold text-muted text-hover-primary fs-7 user-email te-dec-none"
                                                    >
                                                        {nameData.email}
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="separator my-2"></div>
                                        <div>
                                            <div className="menu-item px-4">
                                                <Link
                                                    to="/plans"
                                                    className={`menu-link pe-5 ${location.pathname === "/plans" ? "active-link" : ""}`}
                                                >
                                                    My Subscription
                                                </Link>
                                            </div>
                                            <div className="menu-item my-1 px-4">
                                                <Link
                                                    to="/billing"
                                                    className={`menu-link pe-5 ${location.pathname === "/billing" ? "active-link" : ""}`}
                                                >
                                                    My Billing
                                                </Link>
                                            </div>
                                            <div className="menu-item my-1 px-4">
                                                <Link
                                                    to="/settings"
                                                    className={`menu-link pe-5 ${location.pathname === "/settings" ? "active-link" : ""}`}
                                                >
                                                    Account Settings
                                                </Link>
                                            </div>
                                        </div>
                                        <div className="menu-item px-4">
                                            <Link onClick={handlesignout} className="menu-link pe-5">
                                                <span>Sign Out</span>
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </header>
            </div>
            <div className="d-flex flex-column-fluid flex-lg-row-auto justify-content-center p-12 " style={{ backgroundColor: '#F9F9F9', }}>
                <div className="bg-body d-flex flex-column flex-center justify-content-center rounded-4 w-md-600px p-12 mtone" style={{ height: 'fit-content', justifyContent: 'center' }}>
                    <div className="d-flex flex-center flex-column align-items-stretch  w-md-400px">
                        <div id="kt_aside_logo" className="aside-logo align-items-center py-8">
                            <Link to="/" className="d-flex align-items-center fw-normal ">
                                <img src={logo} alt="logo" width="30%" />
                            </Link>
                        </div>
                        <div className="d-flex flex-center flex-column flex-column-fluid rounded-4 " style={{ background: 'white' }}>

                            <h2>Hi {nameData.name}</h2>
                            <p>Before proceeding, please check your email for a verification link.If you did not receive the email, click the link below.</p>

                            <form className="d-inline mt-3">
                                {loading ? (
                                    <button className="mt-2 btn btn-theme btn-shadow" type="submit" disabled>
                                        Please Wait...
                                        <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                    </button>
                                ) : null}
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <div >
                <div className='footer py-4 d-flex flex-lg-column footerstyle' id='kt_footer'  >
                    <div className=' container-fluid d-flex flex-column flex-md-row align-items-center justify-content-between' >
                        <div className='text-dark order-2 order-md-1' style={{ paddingLeft: '30px' }}>
                            <div className='text-muted fw-semibold me-1'>
                                2025©  <Link to="/" className='text-gray-800 text2-muted text-hover-primary' style={{ textDecoration: 'none' }}>  HeyVisuals</Link>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    );
};

export default Emailconfirm;
